import axios from 'axios';

export default {
    fetchExportableProducts() {
        return axios.post('/glassProducts/fetchExportableProducts');
    },
};
